
import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
const FAQs = lazy(() => import("./pages/FAQs"));
const About = lazy(() => import("./pages/About"));
const BookCourt = lazy(() => import("./pages/BookCourt"));
const Contact = lazy(() => import("./pages/Contact"));
const Events = lazy(() => import("./pages/Events"));
const EventsThankYou = lazy(() => import("./pages/EventsThankYou"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse"));
import NotFound from "./pages/NotFound";
const WiFiSignup = lazy(() => import("./pages/WiFiSignup"));
const EventPackage = lazy(() => import("./pages/EventPackage"));
const MediaDashboard = lazy(() => import("./pages/MediaDashboard"));
const MediaPlayer = lazy(() => import("./pages/MediaPlayer"));
const Levels = lazy(() => import("./pages/Levels"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Press = lazy(() => import("./pages/Press"));
const Tennibot = lazy(() => import("./pages/Tennibot"));
import LandingPage from "./components/landing/LandingPage";
import { landingPagesBySlug } from "./data/landingPages";
import AnnouncementBanner from "./components/AnnouncementBanner";
import ScrollToTop from "./components/ScrollToTop";

const App = () => (
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <AnnouncementBanner />
        <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/levels" element={<Levels />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/about" element={<About />} />
          <Route path="/book" element={<BookCourt />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events-thankyou" element={<EventsThankYou />} />
          <Route path="/wifi" element={<WiFiSignup />} />
          <Route path="/eventpackage" element={<EventPackage />} />
          {/* Legacy short URLs (/open-play, /court-rental, /lessons, /leagues,
              /membership, /ladders) and the six retired level paths (/beginner
              … /advanced) are now real host 301s in public/_redirects. Any that
              slip through on a bare pages.dev SPA navigation fall to NotFound. */}

          {/* Blog */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          
          <Route path="/media" element={<MediaDashboard />} />
          <Route path="/media/player/:screenId" element={<MediaPlayer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/press" element={<Press />} />
          <Route path="/tennibot" element={<Tennibot />} />
          {/* SEO / PPC landing pages — routes declared statically so crawlers
              can discover them. Configs still live in src/data/landingPages.ts
              (shared component pattern). */}
          <Route path="/pickleball-court-rental-brooklyn" element={<LandingPage config={landingPagesBySlug["/pickleball-court-rental-brooklyn"]!} />} />
          <Route path="/indoor-pickleball-courts-brooklyn" element={<LandingPage config={landingPagesBySlug["/indoor-pickleball-courts-brooklyn"]!} />} />
          <Route path="/pickleball-open-play-brooklyn" element={<LandingPage config={landingPagesBySlug["/pickleball-open-play-brooklyn"]!} />} />
          <Route path="/pickleball-lessons-brooklyn" element={<LandingPage config={landingPagesBySlug["/pickleball-lessons-brooklyn"]!} />} />
          <Route path="/corporate-pickleball-events-nyc" element={<LandingPage config={landingPagesBySlug["/corporate-pickleball-events-nyc"]!} />} />
          <Route path="/private-pickleball-events-brooklyn" element={<LandingPage config={landingPagesBySlug["/private-pickleball-events-brooklyn"]!} />} />
          <Route path="/pickleball-packages-brooklyn" element={<LandingPage config={landingPagesBySlug["/pickleball-packages-brooklyn"]!} />} />
          <Route path="/pickleball-leagues-brooklyn" element={<LandingPage config={landingPagesBySlug["/pickleball-leagues-brooklyn"]!} />} />
          <Route path="/pickleball-birthday-party-brooklyn" element={<LandingPage config={landingPagesBySlug["/pickleball-birthday-party-brooklyn"]!} />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
);

export default App;
